// components/industry-templates/MiningEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Pickaxe, Mountain, HardHat, TrendingUp } from 'lucide-react';

export const MiningEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      <Card className="border-0 bg-gradient-to-br from-stone-600/20 to-amber-600/20 backdrop-blur">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2 text-2xl">
            <Pickaxe className="w-8 h-8" style={{ color: theme.primary }} />
            Mining Technology & Safety
            </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4">
            {industryData?.mining_tech?.map((tech: any, idx: number) => (
              <div key={idx} className="p-5 bg-white/10 rounded-xl">
                <h3 className="text-xl font-bold text-white mb-2">{tech.name}</h3>
                <p className="text-slate-300 text-sm mb-3">{tech.description}</p>
                <Badge style={{ backgroundColor: theme.primary }}>{tech.category}</Badge>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
